<template>
  <VApp data-testid="app">
    <SocioBaseNotification />
    <RouterView />
  </VApp>
</template>

<script setup>
import { defineComponent } from "vue";
import SocioBaseNotification from "@/components/base-components/SocioBaseNotification.vue";

defineComponent({
  name: "App",
});
</script>
